import { useMemo } from "react";
import { useRecoilValue } from "recoil";

import { useReportId } from "@ryde/redux";
import {
  reportSearchMatcher,
  reportsTableColumnsVisibilityAF,
  reportTableRowsAF,
  rideFilterSearchAtom,
} from "@ryde/shared";

export const useResolveSearchFilteredRowsReport = (): {
  isSearchWithoutError: boolean;
} => {
  const { reportId } = useReportId();
  const searchValue = useRecoilValue(rideFilterSearchAtom(reportId));
  const columnVisibility = useRecoilValue(
    reportsTableColumnsVisibilityAF(reportId),
  );

  const reportRows = useRecoilValue(reportTableRowsAF(reportId));

  const isSearchWithoutError = useMemo(() => {
    if (!reportRows.length || !searchValue) {
      return true;
    }

    const visibleFieldNames: string[] = Object.entries(columnVisibility)
      .filter(([, value]) => value)
      .map(([key]) => key);

    return reportRows.some(row => {
      return reportSearchMatcher({ row, searchValue, visibleFieldNames });
    });
  }, [columnVisibility, reportRows, searchValue]);

  return { isSearchWithoutError };
};
